/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationByAddressInput = {
  readonly address1?: string | null | undefined;
  readonly address2?: string | null | undefined;
  /** id for an address present in the current session. */
  readonly addressId?: string | number | null | undefined;
  readonly city?: string | null | undefined;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: string | null | undefined;
  readonly lat?: number | null | undefined;
  readonly lon?: number | null | undefined;
  readonly state?: string | null | undefined;
  readonly useCartRestaurant?: boolean | null | undefined;
  readonly zipcode?: number | null | undefined;
};

export type CustomizationDeliveryRestaurantQueryVariables = Exact<{
  input: Types.LocationByAddressInput;
}>;

export type CustomizationDeliveryRestaurantQuery = {
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly deliveryFee: number;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
        };
        readonly vendor: { readonly name: string; readonly restaurantId: string };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export const CustomizationDeliveryRestaurantDocument = gql`
  query CustomizationDeliveryRestaurant($input: LocationByAddressInput!) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        deliveryFee
        restaurant {
          __typename
          id
          slug
        }
        vendor {
          name
          restaurantId
        }
      }
    }
  }
`;

export function useCustomizationDeliveryRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<CustomizationDeliveryRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    CustomizationDeliveryRestaurantQuery,
    CustomizationDeliveryRestaurantQueryVariables
  >({ query: CustomizationDeliveryRestaurantDocument, ...options });
}
